// export const schoolID = "4C6B9694-2954-4CD6-A815-0467DA5B622B";

export const Roles = [
  {
    RoleName: 'Admin',
  },
  {
    RoleName: 'Student',
  },
  {
    RoleName: 'Employee',
  },
  {
    RoleName: 'Parent',
  },
  {
    RoleName: 'Teacher',
  },
];



export const MENU_DATA = [
  {
    subMenuId: 1,
    subMenuName: "Dashboard",
    menuIcon: <i className="fa-light fa-house"></i>,
    routePath: "/",
    isMenuShow: true,
    sortOrder: 1,
    children: [],
    canCreate: true,
    canDelete: true,
    canEdit: true,
    canView: true,
  },
  {
    subMenuId: 2,
    subMenuName: "School Management",
    menuIcon: <i className="fa-light fa-landmark"></i>,
    routePath: "/school-management",
    isMenuShow: true,
    sortOrder: 2,
    children: [],
    canCreate: true,
    canDelete: true,
    canEdit: true,
    canView: true,
  },
  {
    subMenuId: 3,
    subMenuName: "Admin Management",
    menuIcon: <i className="fa-light fa-person"></i>,
    routePath: "/admin-management",
    isMenuShow: true,
    sortOrder: 3,
    children: [],
    canCreate: true,
    canDelete: true,
    canEdit: true,
    canView: true,
  },
  {
    subMenuId: 4,
    subMenuName: "Help Desk",
    menuIcon: <i className="fa-light fa-landmark"></i>,
    routePath: "/helpdesk",
    isMenuShow: true,
    sortOrder: 4,
    children: [],
    canCreate: true,
    canDelete: true,
    canEdit: true,
    canView: true,
  },
   {
    subMenuId: 4,
    subMenuName: "Group List",
    menuIcon: <i className=" fa-light fa-people-group"></i>,
    routePath: "/grouplist",
    isMenuShow: true,
    sortOrder: 4,
    children: [],
    canCreate: true,
    canDelete: true,
    canEdit: true,
    canView: true,
  }
];


// export const MENU_DATA = [
//   {
//     id: 1,
//     name: "Dashboard",
//     icon: <i class="fa-light fa-house"></i>,
//     route: "/",
//     isMenuShow: true,
//     sortOrder: 1,
//     children: []
//   },
//   {
//     id: 2,
//     name: "Students",
//     icon: <i class="fa-light fa-person"></i>,
//     route: "",
//     isMenuShow: true,
//     sortOrder: 2,
//     children: [
//       { id: 21, name: "Student List", route: "/home", isMenuShow: true, sortOrder: 1 },
//       { id: 22, name: "Admission", route: "/students/admission", isMenuShow: true, sortOrder: 2 }
//     ]
//   },
//   {
//     id: 3,
//     name: "Class",
//     icon: <i class="fa-light fa-landmark"></i>,
//     route: "",
//     isMenuShow: true,
//     sortOrder: 3,
//     children: [
//       { id: 31, name: "Manage Class", route: "/school-list", isMenuShow: true, sortOrder: 1 },
//       { id: 32, name: "Sections", route: "/school-management", isMenuShow: true, sortOrder: 2 }
//     ]
//   },
//   {
//     id: 4,
//     name: "Admin",
//     icon: <i class="fa-light fa-landmark"></i>,
//     route: "",
//     isMenuShow: true,
//     sortOrder: 4,
//     children: [
//       { id: 41, name: "Admin", route: "/create-admin", isMenuShow: true, sortOrder: 1 },
//       { id: 42, name: "Sections", route: "/school-management", isMenuShow: true, sortOrder: 2 }
//     ]
//   }
// ];

// export const MENU_DATA = [
//   {
//     subMenuId: 1,
//     subMenuName: "Dashboard",
//     menuIcon: <i className="fa-light fa-house"></i>,
//     routePath: "/",
//     isMenuShow: true,
//     sortOrder: 1,
//     children: [],
//     canCreate: true,
//     canDelete: true,
//     canEdit: true,
//     canView: true,
//   },
//   {
//     subMenuId: 2,
//     subMenuName: "Students",
//     menuIcon: <i className="fa-light fa-person"></i>,
//     routePath: "",
//     isMenuShow: true,
//     sortOrder: 2,
//     children: [
//       { 
//         subMenuId: 21, 
//         subMenuName: "Student List", 
//         routePath: "/students/list", 
//         isMenuShow: true, 
//         sortOrder: 1 
//       },
//       { 
//         subMenuId: 22, 
//         subMenuName: "Admission", 
//         routePath: "/students/admission", 
//         isMenuShow: true, 
//         sortOrder: 2 
//       }
//     ],
//     canCreate: true,
//     canDelete: true,
//     canEdit: true,
//     canView: true,
//   },
//   {
//     subMenuId: 3,
//     subMenuName: "Class",
//     menuIcon: <i className="fa-light fa-landmark"></i>,
//     routePath: "",
//     isMenuShow: true,
//     sortOrder: 3,
//     children: [
//       { 
//         subMenuId: 31, 
//         subMenuName: "Manage Class", 
//         routePath: "/classes/manage", 
//         isMenuShow: true, 
//         sortOrder: 1 
//       },
//       { 
//         subMenuId: 32, 
//         subMenuName: "Sections", 
//         routePath: "/classes/sections", 
//         isMenuShow: true, 
//         sortOrder: 2 
//       }
//     ],
//     canCreate: true,
//     canDelete: true,
//     canEdit: true,
//     canView: true,
//   },
//   {
//     subMenuId: 4,
//     subMenuName: "Admin",
//     menuIcon: <i className="fa-light fa-landmark"></i>,
//     routePath: "",
//     isMenuShow: true,
//     sortOrder: 4,
//     children: [
//       { 
//         subMenuId: 41, 
//         subMenuName: "Admin Users", 
//         routePath: "/admin/users", 
//         isMenuShow: true, 
//         sortOrder: 1 
//       },
//       { 
//         subMenuId: 42, 
//         subMenuName: "Permissions", 
//         routePath: "/admin/permissions", 
//         isMenuShow: true, 
//         sortOrder: 2 
//       }
//     ],
//     canCreate: true,
//     canDelete: true,
//     canEdit: true,
//     canView: true,
//   }
// ];